import script from "./WelfareShell.vue?vue&type=script&setup=true&lang=js"
export * from "./WelfareShell.vue?vue&type=script&setup=true&lang=js"

import "./WelfareShell.vue?vue&type=style&index=0&id=57396cbe&lang=scss"

const __exports__ = script;

export default __exports__